import { Directive, inject } from '@angular/core';
import { CryptoFacade } from '@zero/crypto/domain';

@Directive()
export class OverviewPageBase {
  public cryptoFacade = inject(CryptoFacade);

  public init(): void {
    this.cryptoFacade.loadCryptos();
    this.cryptoFacade.subscribeToCryptoQuotes();
    this.cryptoFacade.loadETPs();
    this.cryptoFacade.subscribeToETPQuotes();
  }

  public destroy(): void {
    this.cryptoFacade.unsubscribeFromCryptoQuotes();
    this.cryptoFacade.unsubscribeFromETPQuotes();
  }
}
